const cdnUrl = 'https://puzzles.cdn.livingsecurity.com/ExamGuide/EntranceExam';
const storeCdn = 'https://puzzles.cdn.livingsecurity.com/ExamGuide/StoreExam';

// Note: Strings should map to a translation key in './locales/en'
export default function getEntranceExamData() {
  return {
    backgroundImage: 'https://puzzles.cdn.livingsecurity.com/CEO/EntranceExam/GameBG.jpg',
    files: [
      {
        nameKey: 'scaffolding-poster',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle1_Scaffolding_Poster_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'invoice',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle2_Invoice_v2.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'clickbait-report',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle3a_Clickbait_Report_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'jetfuel-energy',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle3b_JetFuel_Energy_v1.jpg`,
        type: 'IMAGE',
      },
      /*
      {
        nameKey: 'laptop-receipt',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle3c_Laptop_Receipt_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'happy-hour',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle3d_Happy_Hour_v1.jpg`,
        type: 'IMAGE',
      },
       */
      {
        nameKey: 'suspicious-behaviors',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle4_Suspicious_Behaviors_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'response-guide-cover',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle6a_ResponseGuide1_Cover_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'response-guide-dataleak',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle6b_ResponseGuide2_DataLeak_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'response-guide-physical-security',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle6c_ResponseGuide3_PhysicalSecurity_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'response-guide-hardware-software',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle6d_ResponseGuide4_HardwareSoftware_v1.jpg`,
        type: 'IMAGE',
      },
      {
        nameKey: 'response-guide-return-abuse',
        clueKey: 'examine',
        src: `${cdnUrl}/EE_STORE_Puzzle6e_ResponseGuide5_ReturnAbuse_v1.jpg`,
        type: 'IMAGE',
      },
    ],
    puzzles: [
      {
        nameKey: 'puzzle-storespot-store',
        clueKey: 'examine',
        src: `${storeCdn}/storespot.jpg`,
        url: 'https://storespot.livingsecurity.com',
        type: 'PUZZLE',
      },
      {
        nameKey: 'puzzle-vishing-store',
        clueKey: 'examine',
        src: `${storeCdn}/vishafridge.jpg`,
        url: 'https://vishafridge.livingsecurity.com',
        type: 'PUZZLE',
      },
      {
        nameKey: 'puzzle-wall-e-worldphish-store',
        clueKey: 'examine',
        src: `${storeCdn}/wall-e-worldphish.jpg`,
        url: 'https://wall-e-worldphish.livingsecurity.com',
        type: 'PUZZLE',
      },
      {
        nameKey: 'puzzle-storeinsider-store',
        clueKey: 'examine',
        src: `${storeCdn}/storeinsider.jpg`,
        url: 'https://storeinsider.livingsecurity.com',
        type: 'PUZZLE',
      },
      {
        nameKey: 'puzzle-storereact-store',
        clueKey: 'examine',
        src: `${storeCdn}/storereact.jpg`,
        url: 'https://storereact.livingsecurity.com',
        type: 'PUZZLE',
      },
    ],
  };
}
